export const CurrencyAndCode = [
    { country: 'ca', currency: 'CAD' },
    { country: 'ch', currency: 'CHF' },
    { country: 'cn', currency: 'CNY' },
    { country: 'eg', currency: 'EGP' },
    { country: 'eu', currency: 'EUR' },
    { country: 'gb', currency: 'GBP' },
    { country: 'hk', currency: 'HKD' },
    { country: 'il', currency: 'ILS' },
    { country: 'in', currency: 'INR' },
    { country: 'jp', currency: 'JPY' },
    { country: 'kr', currency: 'KRW' },
    { country: 'ma', currency: 'MAD' },
    { country: 'pk', currency: 'PKR' },
    { country: 'tr', currency: 'TRY' },
    { country: 'us', currency: 'USD' },
    { country: 'vn', currency: 'VND' },
    { country: 'za', currency: 'ZAR' }
];

export const DefaultCurrencyToISO = [
    { defaultCurrency: 'FCFA', currencyISOCode: 'XAF' },
    { defaultCurrency: 'R', currencyISOCode: 'ZAR' },
    { defaultCurrency: 'DH', currencyISOCode: 'MAD' },
    { defaultCurrency: 'RWF', currencyISOCode: 'RWF' },
    { defaultCurrency: 'CFA', currencyISOCode: 'XOF' },
    { defaultCurrency: 'USh', currencyISOCode: 'UGX' },
    { defaultCurrency: 'TSh', currencyISOCode: 'TZS' },
    { defaultCurrency: 'KSh', currencyISOCode: 'KES' },
]
